import { Button, Form, Col, Offcanvas, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import HelperService from "../../utility/HelperService";
import WebService from "../../utility/WebService";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
}

const headers: GridHeader[] = [
    {
        title: "Project Name",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Booking ID",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Unit Name",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Area",
        class: "text-left",
        isSorting: false
    }
];

const CustomerDetail = (props: PropData) => {
    const [rows, setRows] = useState<GridRow[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.isShow && props.data && !HelperService.isEmptyObject(props.data)) {
            getCustomerDetail()
        }
    }, [props.isShow, props.data]);

    const closeModal = (e: boolean) => {
        props.isClose(e);
    };

    const getCustomerDetail = () => {
        setIsLoading(true);
        WebService.getAPI({ action: `customer/booking/detail/${props.data.uuid}` }).then((res: any) => {
            setIsLoading(false);
            const bookings = res.bookings || [];
            let rows: GridRow[] = [];
            for (let i = 0; i < bookings.length; i++) {
                let columns: GridColumn[] = [];
                for (let j = 0; j < bookings[i].booked_units.length; j++) {
                    columns.push({ value: bookings[i]?.project?.project_name ? bookings[i]?.project?.project_name : "N/A" });
                    columns.push({ value: bookings[i].book_id ? bookings[i].book_id : "N/A" });
                    columns.push({ value: bookings[i].booked_units[j].unit_name ? bookings[i].booked_units[j].unit_name : "N/A" });
                    columns.push({ value: bookings[i].booked_units[j].area ? bookings[i].booked_units[j].area : "N/A" });
                    rows.push({ data: columns, classname: `${new Date().getTime()}_${i}_${j}` });
                }
            }
            setRows(rows);

        }).catch((err) => { setIsLoading(false); toast.error(err.message || "Something went wrong"); });
    };

    return (
        <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
            <Offcanvas.Header closeButton><Offcanvas.Title>Customer Detail</Offcanvas.Title></Offcanvas.Header>
            <Offcanvas.Body className="form-style">
                <Grid
                    rows={rows}
                    headers={headers}
                    showDateFilter={false}
                    errorMessage={"No Royalty Found"}
                    ShowLoader={isLoading}
                />
            </Offcanvas.Body>
        </Offcanvas >
    );
};

export default CustomerDetail;
